import React, { useState } from 'react';

import { useAppDispatch } from 'segments/hooks';

import {
  useGetProductsListQuery,
  changeProductsActiveModal,
} from 'features/products';

import { ProductsModals, ProductsTable } from 'widgets/products';

const defaultPageSize = 30;

const initParams = {
  page: 1,
  pageSize: defaultPageSize,
};

const Products = () => {
  const dispatch = useAppDispatch();
  const [selectedProductId, setSelectedProductId] = useState<number | string | null>(null);
  const [params, setParams] = useState(initParams);

  const {
    productsList,
    productsCount,
    isProductsFetching,
  } = useGetProductsListQuery(undefined, {
    selectFromResult: ({ data, isFetching }) => ({
      productsList: data ?? [],
      productsCount: data?.length ?? 0,
      isProductsFetching: isFetching,
    })
  });

  const handleEditClick = (id: number | string) => {
    setSelectedProductId(id);
    dispatch(changeProductsActiveModal('edit-product-modal'));
  };

  const handlePaginationChange = (page: number, pageSize: number) => {
    setParams((prev) => ({
      ...prev,
      page,
      pageSize,
    }));
  };

  const selectedData = productsList.find((product) => product.id === selectedProductId);

  return (
    <div>
      <ProductsTable
        items={productsList}
        itemsTotal={productsCount}
        currentPage={params.page}
        defaultPageSize={defaultPageSize}
        onPageChange={handlePaginationChange}
        isLoading={isProductsFetching}
        onEditClick={handleEditClick}
      />
      <ProductsModals
        selectedProduct={selectedData}
      />
    </div>
  );
};

export default Products;
